import Main from "../../components/layout/Main";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {Row, Col, Card, Table, Button, Input, Tag, Tabs, Tooltip, DatePicker} from "antd";
import moment from "moment/moment";
import apiPath from "../../constants/apiPath";
import {Severty, ShowToast} from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import useDebounce from "../../hooks/useDebounce";
import {Link} from "react-router-dom";
import {PRICE} from "../../constants/conts";
const Search = Input.Search;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;


function Index() {
    const navigate = useNavigate();

    const [searchText, setSearchText,] = useState('');
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [endDate, setEndDate] = useState();
    const [startDate, setStartDate] = useState();
    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const { request } = useRequest()
    const debouncedSearchText = useDebounce(searchText, 300);
    const [list, setList] = useState([])
    const [selected, setSelected] = useState();
    const [visible, setVisible] = useState(false);
    const [orderId, setOrderId] = useState();
    const [statusVisible, setStatusVisible] = useState(false);
    const [statusRefresh, setStatusRefresh] = useState(false)

    const handleChange = (pagination, filters) => {
        fetchData(pagination, filters);
    }

    const view = (record) => {
        navigate(`/new-order/view/${record._id}`)
    }
    const onSearch = (e) => {
        setSearchText(e.target.value)
        setPagination({ current: 1 })
    };
    const assignWasher = (id) => {
        if(id){
            setVisible(true)
        }
    };
    useEffect(() => {
        setLoading(true)
        fetchData(pagination)
    }, [refresh, statusRefresh, debouncedSearchText, startDate, endDate])
    const changeStatus = (id) => {
        setOrderId(id);
        setStatusVisible(true)
    };
    const handleChangeDate = (e) => {
        if(e!=null){
            setStartDate(moment(e[0]._d).format("YYYY-MM-DD"))
            setEndDate(moment(e[1]._d).format("YYYY-MM-DD"))
        }else{
            setStartDate()
            setEndDate()
        }
    };
    const handleTabChange = (status) => {
        fetchData(pagination, '', status)
    };
    const fetchData = (pagination, filters, orderStatus) => {
        const filterPaymentMethod = filters ? filters.payment_method : null;
        setLoading(true)
        request({
            url: apiPath.listNewOrder + `?payment_method=${filterPaymentMethod ? filterPaymentMethod.join(',') : ''}&order_type=${'OnDemand'}&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10}&order_status=${orderStatus ? orderStatus : "all"}&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""}&end_date=${endDate ? endDate : ""}`,
            method: 'GET',
            onSuccess: (data) => {
                setLoading(false)
                setList(data.data.list.docs)
                setPagination(prev => ({ current: pagination.current, total: data.data.list.totalDocs }))
            },
            onError: (error) => {
                ShowToast(error, Severty.ERROR)
            }
        })
    }
    const columns = [
        {
            title: "Order ID",
            dataIndex: "random_order_id",
            key: "random_order_id",
            render: (_, { random_order_id, _id }) => {
                if (random_order_id) {
                    return <Link className="cap" to={`/on-demand-order/view/${_id}`}>{random_order_id}</Link>;
                } else {
                    return '-';
                }
            },
        },
        {
            title: "Customer Name",
            render: (_, { user_id }) => {
                if (user_id) {
                    return <a target="_blank" className="cap" href={`/customer/view/${user_id._id}`}>{(user_id ? user_id.name : '-')}</a>
                } else {
                    return '-';
                }
                /* (user_id ? user_id.name : '') + " (" + (user_id ? (user_id.country_code ? "+" + user_id.country_code + "-" : "+968") + (user_id.mobile_number ? user_id.mobile_number : '') + ")" : '-') */
            },
        },
        {
            title: "Amount ("+PRICE +")",
            dataIndex: "total",
            key: "total",
            render: (_, { total }) => {
                return total ? total : '-';
            },
        },
        {
            title: "Payment Method",
            dataIndex: "payment_method",
            key: "payment_method",
            filters: [
                {
                    text: 'Online',
                    value: 'Online',
                },
                {
                    text: 'Cod',
                    value: 'Cod',
                },
            ],
            render: (_, { payment_method }) => {
                let color = payment_method == 'Online' ? 'gold' : 'cyan';
                return ( <Tag color={color} key={payment_method} >{payment_method}</Tag> );
            },
        },
        {
            title: "Discount Code",
            dataIndex: "discount_code",
            key: "discount_code",
            render: (_, { discount_code }) => {
                return discount_code ? discount_code : '-';
            },
        },

        {
            title: "Discount amount ("+PRICE +")",
            dataIndex: "discount_amount",
            key: "discount_amount",
            render: (_, { discount_amount }) => {
                return discount_amount ? discount_amount : '-';
            },
        },


        {
            title: "Status",
            key: "status",
            render: (_, { status, _id }) => {
                let color = status === "complete" ? "green" : status === "cancel" ? "red" : status === "new" ? "#007bff" : status === "in-progress" ? "blue" : "yellow" ;
                return (
                    <span><Tag onClick={(e) => !(status === "new" || status === "complete" || status === "cancel") ? null : null} color={color} key={status}>
                        {
                            status === "assign" ? "Assigned" :
                                status === "accept" ? "Accepted" :
                                    status === "confirm" ? "Confirmed" :
                                        status === "reach" ? "Reached" :
                                            status === "in-progress" ? "In-Progress" :
                                                status === "complete" ? "Completed" :
                                                    status === "cancel" ? "Cancelled" :
                                                        "New"
                        }
                    </Tag></span>
                );
            },
        },
        {
            title: "Ordered On",
            key: "created_at",
            dataIndex:   "created_at",
            render: (_, { created_at }) => {
                return (
                    moment(created_at).format('DD-MM-YYYY, hh:mm A')
                );
            },
        },    {
            title: "Completion Time",
            key: "completionTime",
            dataIndex: "completionTime",

        }, {
            title: "Item Count.",
            key: "items_count",
            dataIndex: "items_count",

        },
        {
            title: "Action",
            fixed: 'right',
            render: (_, record) => {
                return (
                    <>
                        <Tooltip title="View Order" color={"purple"} key={"vieworder"}>
                            <Button onClick={(e) => view(record)}>
                                <i className="fa fa-light fa-eye"></i>
                            </Button>
                        </Tooltip>
                    </>
                );
            },
        },
    ];

    return (
        <Main>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Order List"
                            extra={
                                <>
                                    <Search
                                        size="large"
                                        onChange={onSearch}
                                        onPressEnter={onSearch}
                                        value={searchText}
                                        placeholder="Search By Order ID"
                                    />
                                    <RangePicker onChange={handleChangeDate} />
                                </>
                            }
                        >
                            <Tabs onTabClick={handleTabChange} tabBarStyle={{ color: 'green' }}>

                                <TabPane tab="All Orders" key="all">
                                    <div className="table-responsive customPagination">
                                        <Table
                                            loading={loading}
                                            columns={columns}
                                            dataSource={list}
                                            pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, showQuickJumper: true, pageSizeOptions: ['10', '20', '30', '50']}}
                                            onChange={handleChange}
                                            className="ant-border-space"
                                        />
                                    </div>
                                </TabPane>


                            </Tabs>




                        </Card>
                    </Col>
                </Row>

            </div>
        </Main>
    )

}

export default Index;